import { render, staticRenderFns } from "./chips.component.vue?vue&type=template&id=c52fc11e&scoped=true&"
import script from "./chips.component.vue?vue&type=script&lang=js&"
export * from "./chips.component.vue?vue&type=script&lang=js&"
import style0 from "./chips.component.vue?vue&type=style&index=0&id=c52fc11e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52fc11e",
  null
  
)

export default component.exports